import * as _ from "lodash";
import "select2";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions
} from "../../dashboard/modify_widgets/_BaseModifyWidgetView";


export class ModifySignatureWidgetView extends BaseModifyDashboardWidgetView {

    private template = _.template(require('templates/modals/reports/modify_widgets/signaturewidget/signaturewidget.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            tagName: "div",
            className: 'widget-type-channels',
            events: {}
        }, options));

        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
        }
    }

    render() {
        this.$el.html(this.template({
            exampleImg: require('../../../../../img/widgettypes/signature/signaturewidgetexample.png')
        }));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifySignatureWidgetView.ts